var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 4.71999L15.4 0.859985L14.11 2.38999L18.71 6.24999L20 4.71999ZM5.88 2.38999L4.6 0.859985L0 4.70999L1.29 6.23998L5.88 2.38999ZM10 2.99999C5.03 2.99999 1 7.02999 1 12C1 16.97 5.02 21 10 21C14.97 21 19 16.97 19 12C19 7.02999 14.97 2.99999 10 2.99999ZM10 19C6.13 19 3 15.87 3 12C3 8.12999 6.13 4.99999 10 4.99999C13.87 4.99999 17 8.12999 17 12C17 15.87 13.87 19 10 19ZM8.54 13.53L6.41 11.4L5.35 12.46L8.53 15.64L14.53 9.63999L13.47 8.57999L8.54 13.53Z","fill":"#323232"}));
}

Clock.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
